<template>
  <div>
    <br>
    <v-portlet class="box green">
      <div slot="title" class="portlet-title">
        <div slot="caption" class="caption">
          <i class="icon-wallet"></i>
          Transactions
        </div>
        <div slot="actions" class="actions">
        </div>
      </div>

      <div slot="body">
        <v-datatables v-if="showDatatable"
                      :headers="headers"
                      :serverSide="true"
                      :searching="false"
                      :searchableColumns="searchableColumns"
                      :searchableDateColumns="searchableDateColumns"
                      :searchableNumericColumns="searchableNumericColumns"
                      :url="endpoint"
                      :dataFilter="dataFilter"
                      :fixedColumns="true"
                      :buttons="dtButtons"
                      ref="dt"
        ></v-datatables>
      </div>
    </v-portlet>
  </div>
</template>
<script>
  /* ============
     * CLO Deal Table Component
     * ============
     *
     */
  import {serialize} from '@/app/helpers'
  import VDatatables from '@/app/components/datatables/Datatable'
  import VPortlet from '@/app/components/Portlet'
  import TransactionsTransformer from '@/app/transformers/TransactionTransformer'
  import TransactionsCSVLinkProxy from '@/app/proxies/TransactionsCSVLinkProxy'

  export default {
    components: {
      VDatatables,
      VPortlet
    },
    data () {
      return {
        headers: [
          {title: 'offerId', prop: 'dealId'},
          {title: 'offerName', prop: 'offerName'},
          {title: 'transactionSequenceNumber', prop: 'transactionSequenceNumber'},
          {title: 'trxDate', prop: 'trxDate'},
          {title: 'time', prop: 'trxDate'},
          {title: 'firstClaim', prop: 'firstClaim'},
          {title: 'ccNumber', prop: 'ccFirstLast'},
          {title: 'amount', prop: 'amount'},
          {title: 'tipPercentage', prop: 'tipPercentage'},
          {title: 'amountBeforeTip', prop: 'amountBeforeTip'},
          {title: 'cashbackPercentage', prop: 'cashbackPercentage'},
          {title: 'cashbackAmount', prop: 'cashbackAmount'},
          {title: 'cashbackAmountBeforeTax', prop: 'cashbackAmountBeforeTax'},
          {title: 'provincialTaxCashbackAmount', prop: 'provincialTaxCashbackAmount'},
          {title: 'federalTaxCashbackAmount', prop: 'federalTaxCashbackAmount'},
          {title: 'combinedTaxRate', prop: 'combinedTaxRate'},
          {title: 'estimatedAmountBeforeTipAndTaxes', prop: 'estimatedAmountBeforeTipAndTaxes'},
          {title: 'marketingFee', prop: 'marketingFee'},
          {title: 'marketingFeeAmount', prop: 'marketingFeeAmount'},
          {title: 'provincialTaxMarketingFeeAmount', prop: 'provincialTaxMarketingFeeAmount'},
          {title: 'federalTaxMarketingFeeAmount', prop: 'federalTaxMarketingFeeAmount'},
          {title: 'totalMarketingFeeInclTax', prop: 'totalMarketingFeeInclTax'},
          // {title: 'invoiceId', prop: 'invoiceId'},
          {title: 'invoiceNumber', prop: 'invoiceNumber'},
          {title: 'status', prop: 'status'}
        ],
        searchableColumns: [
          {title: 'offerId', apiTitle: 'dealId', prop: 'dealId'},
          {title: 'ccNumber', apiTitle: 'ccNumber', prop: 'ccFirstLast'},
          {title: 'status', apiTitle: 'status', prop: 'status'},
          {title: 'invoiceNumber', apiTitle: 'invoiceNumber', prop: 'invoiceNumber'},
          {title: 'transactionSequenceNumber', apiTitle: 'transactionSequenceNumber', prop: 'transactionSequenceNumber'},
          {title: 'offerName', apiTitle: 'deal.title', prop: 'offerName'}
        ],
        searchableDateColumns: [
          {title: 'trxDate', prop: 'trxDateET'},
          {title: 'firstClaim', prop: 'firstClaimET'}
        ],
        searchableNumericColumns: [
          {title: 'amount', prop: 'amount'},
          {title: 'amountBeforeTip', prop: 'amountBeforeTip'},
          {title: 'cashbackAmount', prop: 'cashbackAmount'},
          {title: 'cashbackAmountBeforeTax', prop: 'cashbackAmountBeforeTax'},
          {title: 'cashbackPercentage', prop: 'cashbackPercentage'},
          {title: 'combinedTaxRate', prop: 'combinedTaxRate'},
          {title: 'estimatedAmountBeforeTipAndTaxes', prop: 'estimatedAmountBeforeTipAndTaxes'},
          {title: 'federalTaxMarketingFeeAmount', prop: 'federalTaxMarketingFeeAmount'},
          {title: 'federalTaxCashbackAmount', prop: 'federalTaxCashbackAmount'},
          {title: 'marketingFee', prop: 'marketingFee'},
          {title: 'marketingFeeAmount', prop: 'marketingFeeAmount'},
          {title: 'provincialTaxCashbackAmount', prop: 'provincialTaxCashbackAmount'},
          {title: 'provincialTaxMarketingFeeAmount', prop: 'provincialTaxMarketingFeeAmount'},
          {title: 'tipPercentage', prop: 'tipPercentage'},
          {title: 'totalMarketingFeeInclTax', prop: 'totalMarketingFeeInclTax'}
        ],
        tableData: null,
        endpoint: `${process.env.CLO_PHP_API_URL}/${process.env.CLO_PHP_API_ENV}_clo_capture_transactions_processings`,
        dataFilter: TransactionsTransformer,
        transactionsCSVLinkProxy: null,
        showDatatable: true
      }
    },
    computed: {
      dtButtons () {
        return [
          {
            extend: 'copy',
            className: 'dt-button btn default',
            text: this.$t(`messages.BTN_COPY`)
          },
          {
            extend: 'print',
            className: 'dt-button btn default',
            text: this.$t(`messages.BTN_PRINT`)
          },
          {
            text: 'CSV',
            className: 'dt-button btn default',
            action: this.getCSV
          }
        ]
      },
      lang () {
        return this.$store.state.locale.current
      },
      selectedDeal () {
        return this.$store.state.app.selectedDeal
      }
    },
    watch: {
      lang () {
        this.showDatatable = false
        this.$nextTick(() => {
          this.showDatatable = true
        }, 5)
      }
    },
    methods: {
      getCSV () {
        // prepare query parameters
        const requestData = Object.assign({}, this.$refs.dt.lastRequestData)
        delete requestData['draw']
        requestData['itemsPerPage'] = 1000
        requestData['lang'] = this.lang
        const qs = serialize(requestData)

        this.$notify.info({
          title: this.$t('messages.PREPARING_DATA'),
          message: this.$t('messages.DOWNLOAD_MSG')
        })

        this.transactionsCSVLinkProxy.submit('get', this.transactionsCSVLinkProxy.endpoint + '?' + qs)
          .then(res => {
            window.location.href = process.env.CLO_PHP_API_URL + res['data']['link']
          })
          .catch(err => {
            console.log(err)
          })
      },
      getInvoceLink (e) {
        this.$api.invoiceInvoiceIdInvoiceNumberGet({
          invoice_id: $(e.target).data('invoiceid'),
          invoice_number: $(e.target).data('invoicenumber')
        })
          .then(res => {
            window.open(res.data['url']['invoice_url'], '_blank')
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    created () {
      this.transactionsCSVLinkProxy = new TransactionsCSVLinkProxy()
    },
    mounted () {
      const vm = this
      $('body').on('click', `[data-invoicenumber]`, vm.getInvoceLink)
    },
    beforeDestroy () {
      const vm = this
      $('body').off('click', `[data-invoicenumber]`, vm.getInvoceLink)
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/pages/Logs/Transactions.vue